import { StatBar } from '../stats/StatBar'
import { Histogram } from '../stats/Histogram'
import { shareStatus } from '../../lib/share'
import { BaseModal } from './BaseModal'
import {
  STATISTICS_TITLE,
  GUESS_DISTRIBUTION_TEXT,
  SHARE_TEXT,
} from '../../constants/strings'

export const StatsModal = ({
  isOpen,
  handleClose,
  guesses,
  gameStats,
  isGameLost,
  isGameWon,
  handleShareToClipboard,
  isHardMode,
  isDarkMode,
  isHighContrastMode,
  solution,
  definition,
  handlePlayAgain,
}) => {
  const showGameResult = isGameLost || isGameWon

  return (
    <BaseModal title="" isOpen={isOpen} handleClose={handleClose}>
      {showGameResult && (
        <div className="mt-5 sm:mt-5">
          <div className="mb-4">
            <h4 className="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100 mb-2">
              Definición
            </h4>
            <h5>
              <strong>{solution}</strong> — {definition?.definition}
              {definition?.example && <br />}
              {definition?.example && <i>Ejemplo: "{definition.example}"</i>}
            </h5>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              type="button"
              className="flex-1 rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:text-sm"
              onClick={handlePlayAgain}
            >
              Jugar Nuevamente
            </button>

            <button
              type="button"
              className="flex-1 rounded-md border border-transparent shadow-sm px-4 py-2 bg-customBlue text-base font-medium text-white hover:bg-customBlue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-customBlue sm:text-sm"
              onClick={() => {
                shareStatus(
                  guesses,
                  isGameLost,
                  isHardMode,
                  isDarkMode,
                  isHighContrastMode,
                  handleShareToClipboard
                )
              }}
            >
              {SHARE_TEXT}
            </button>
          </div>
        </div>
      )}

      <div className="mt-5">
        Envíanos tus sugerencias vía{' '}
        <a
          href="https://www.instagram.com/tucudle/"
          className="underline font-bold"
          target="_blank"
          rel="noopener noreferrer"
        >
          Instagram
        </a>{' '}
      </div>

      <h4 className="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100">
        <br />
        {STATISTICS_TITLE}
      </h4>

      <StatBar gameStats={gameStats} />
      <h4 className="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100">
        {GUESS_DISTRIBUTION_TEXT}
      </h4>
      <Histogram gameStats={gameStats} />
    </BaseModal>
  )
}